export const addBindingsToStringValue = (str: string) => {
  if (str.slice(0, 2) !== "{{") {
    str = "{{" + str;
  }
  if (str.slice(-2) !== "}}") {
    str += "}}";
  }
  return str;
};

export const removeBindingsFromStringValue = (str: string) => {
  if (str.slice(0, 2) === "{{") {
    str = str.slice(2);
  }
  if (str.slice(-2) === "}}") {
    str = str.slice(0, -2);
  }
  return str;
};
